export enum FixCourseMergingMethodEnum {
  NeverMerge = "NeverMerge",
  AllowMerging = "AllowMerging",
}
